module.exports = __webpack_public_path__ + "static/audio-a8c4cb1503b89b98b6f629c7c4eac9cd.mp3";